const SignalLogo = () => (
  <svg
    id="Group_18"
    data-name="Group 18"
    xmlns="http://www.w3.org/2000/svg"
    width="127.939"
    height="50.676"
    viewBox="0 0 127.939 50.676"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_74"
          data-name="Rectangle 74"
          width="127.939"
          height="50.676"
          fill="#fff"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <rect
          id="Rectangle_73"
          data-name="Rectangle 73"
          width="127.939"
          height="50.676"
          transform="translate(0 0)"
          fill="#fff"
        />
      </clipPath>
      <clipPath id="clip-path-3">
        <rect
          id="Rectangle_72"
          data-name="Rectangle 72"
          width="6.694"
          height="36.337"
          fill="#5f6ffe"
        />
      </clipPath>
    </defs>
    <g id="Group_17" data-name="Group 17" clipPath="url(#clip-path)">
      <g id="Group_16" data-name="Group 16">
        <g id="Group_15" data-name="Group 15" clipPath="url(#clip-path-2)">
          <path
            id="Path_17"
            data-name="Path 17"
            d="M0,41.367H7.159a2.672,2.672,0,0,0,2.97,2.675c1.453,0,2.841-.773,2.841-2.149,0-1.58-1.961-2.038-4.358-2.619-3.64-.9-8.288-2.02-8.288-7.755,0-4.96,3.645-7.8,9.584-7.8,6.039,0,9.5,3.1,9.5,8.225H12.45A2.324,2.324,0,0,0,9.824,29.6c-1.236,0-2.424.535-2.424,1.711,0,1.431,1.9,1.9,4.27,2.5,3.707.956,8.555,2.195,8.555,7.947,0,5.5-4.227,8.357-10.076,8.357C3.984,50.116,0,46.857,0,41.367"
            transform="translate(0 -13.05)"
            fill="#fff"
          />
          <rect
            id="Rectangle_67"
            data-name="Rectangle 67"
            width="6.693"
            height="19.431"
            transform="translate(22.629 17.019)"
            fill="#fff"
          />
          <path
            id="Path_18"
            data-name="Path 18"
            d="M91.28,37.08V54.352c0,6.106-4,9.888-10.415,9.888-5.514,0-9.374-2.781-10.268-7.385h6.459c.463,1.3,2.122,2,3.748,2a3.743,3.743,0,0,0,4.045-3.736v-.58A9.673,9.673,0,0,1,70.067,46.23a9.525,9.525,0,0,1,9.71-9.772,9.373,9.373,0,0,1,6.129,2.252l.849-1.63ZM80.889,50.486A4.247,4.247,0,1,0,76.74,46.23a4.048,4.048,0,0,0,4.148,4.256Z"
            transform="translate(-38.552 -20.06)"
            fill="#fff"
          />
          <path
            id="Path_19"
            data-name="Path 19"
            d="M143.837,44.72V56.568h-6.693V45.644c0-2.262-.85-3.384-2.534-3.384-2.087,0-3.287,1.458-3.287,3.931V56.568H124.63V37.137h4.7l.919,2a8.077,8.077,0,0,1,6.117-2.579c4.512,0,7.476,3.207,7.476,8.158"
            transform="translate(-68.574 -20.117)"
            fill="#fff"
          />
          <path
            id="Path_20"
            data-name="Path 20"
            d="M193.546,37.078V56.508h-5.174l-.573-1.374a9.208,9.208,0,0,1-5.864,2.031c-5.941,0-10.189-4.334-10.189-10.373a9.861,9.861,0,0,1,10.189-10.3,9.218,9.218,0,0,1,5.937,2.088l.685-1.5Zm-6.366,9.731a4.351,4.351,0,1,0-4.349,4.432,4.268,4.268,0,0,0,4.349-4.432"
            transform="translate(-94.499 -20.079)"
            fill="#fff"
          />
          <rect
            id="Rectangle_68"
            data-name="Rectangle 68"
            width="6.694"
            height="26.831"
            transform="translate(102.364 9.506)"
            fill="#fff"
          />
          <path
            id="Path_21"
            data-name="Path 21"
            d="M57.066,18.636a3.321,3.321,0,1,1-3.321-3.321,3.321,3.321,0,0,1,3.321,3.321"
            transform="translate(-27.744 -8.427)"
            fill="#fff"
          />
          <g id="Group_14" data-name="Group 14" transform="translate(121.245)" opacity="0.8">
            <g id="Group_13" data-name="Group 13">
              <g id="Group_12" data-name="Group 12" clipPath="url(#clip-path-3)">
                <rect
                  id="Rectangle_71"
                  data-name="Rectangle 71"
                  width="6.694"
                  height="36.337"
                  fill="#5f6ffe"
                />
              </g>
            </g>
          </g>
          <path
            id="Path_22"
            data-name="Path 22"
            d="M131.837,93.465a3.312,3.312,0,0,1-3.4,3.421,3.107,3.107,0,0,1-2.028-.725l-.207.541H124.9V87.894h1.751v2.684a3.128,3.128,0,0,1,1.777-.534,3.311,3.311,0,0,1,3.4,3.421m-1.784,0a1.764,1.764,0,1,0-1.764,1.765,1.72,1.72,0,0,0,1.764-1.765"
            transform="translate(-68.726 -48.361)"
            fill="#fff"
          />
          <path
            id="Path_23"
            data-name="Path 23"
            d="M147.266,93.082l-2.823,6.39c-.776,1.755-1.459,2.42-2.912,2.42h-.721v-1.574h.606c.844,0,1.062-.225,1.461-1.2l.024-.052-2.744-5.98h1.906l1.728,3.984,1.613-3.984Z"
            transform="translate(-77.118 -51.216)"
            fill="#fff"
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M166.193,93v1.652h-.76c-.987,0-1.377.437-1.377,1.5v3.364h-1.751V93.039h1.123l.31.793A2.212,2.212,0,0,1,165.618,93Z"
            transform="translate(-89.304 -51.172)"
            fill="#fff"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M177.906,96.586H173a1.51,1.51,0,0,0,1.583,1.37,1.537,1.537,0,0,0,1.374-.751h1.84a3.543,3.543,0,1,1,.139-1.133,4.1,4.1,0,0,1-.033.514m-4.855-1.2h3.137a1.592,1.592,0,0,0-1.6-1.221,1.519,1.519,0,0,0-1.536,1.221"
            transform="translate(-94.214 -50.992)"
            fill="#fff"
          />
          <path
            id="Path_26"
            data-name="Path 26"
            d="M187.315,96.076a3.348,3.348,0,0,1,3.449-3.4,3.241,3.241,0,0,1,3.293,2.656h-1.739a1.686,1.686,0,0,0-3.228.755,1.7,1.7,0,0,0,1.664,1.784,1.653,1.653,0,0,0,1.563-1.086h1.762a3.286,3.286,0,0,1-3.325,2.732,3.384,3.384,0,0,1-3.439-3.44"
            transform="translate(-103.065 -50.992)"
            fill="#fff"
          />
          <path
            id="Path_27"
            data-name="Path 27"
            d="M203.321,96.1a3.5,3.5,0,1,1,3.5,3.421,3.371,3.371,0,0,1-3.5-3.421m5.227,0a1.726,1.726,0,1,0-1.726,1.775,1.677,1.677,0,0,0,1.726-1.775"
            transform="translate(-111.872 -50.992)"
            fill="#fff"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M230.669,95.309V99.37h-1.752V95.6c0-.865-.339-1.321-.973-1.321-.781,0-1.245.576-1.245,1.59v3.5h-1.707V95.6c0-.865-.329-1.321-.956-1.321-.792,0-1.265.576-1.265,1.59v3.5h-1.751V92.894h1.223l.329.8a2.488,2.488,0,0,1,1.931-.957,2.1,2.1,0,0,1,1.88,1.037,2.45,2.45,0,0,1,2-1.037,2.331,2.331,0,0,1,2.281,2.569"
            transform="translate(-121.611 -51.028)"
            fill="#fff"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M0,0H6.694V31.66H0Z"
            transform="translate(111.74 4.676)"
            fill="#5f6ffe"
            opacity="0.8"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SignalLogo;
